import React, { useContext } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'

// routes config
import { GlobalContext } from '../views/context/GlobalState'
import { PERMISSIONS } from '../views/utils/permissions'
import CreateEditAccounts from '../views/container/accounts/createEditAccount'
import ManageAccounts from '../views/container/accounts'
import ArtistsTypes from '../views/container/artists/artistTypes'
import Dashboard from '../views/dashboard/Dashboard'
import CreateContent from '../views/container/cms/CreateContent'
import Subscription from '../views/container/pricing/Subscription'
import SystemDefined from '../views/container/metaData/system'
import CustomMetaDataListing from '../views/container/metaData/custom'
import StaticPages from '../views/container/staticPages/StaticPages'
import Discount from '../views/container/pricing/Discount'
import RolesList from '../views/container/userManagement/roles'
import CmsUserList from '../views/container/userManagement/cmsUser'
import SubscriberList from '../views/container/userManagement/subscriber/subscriberList'
import UserGroupList from '../views/container/userManagement/userGroups/UserGroupList'
import Artists from '../views/container/artists'
import ContentRating from '../views/container/contentRating/contentRating'
import Venues from '../views/container/venues'
import SubscriptionAnalytics from '../views/container/analytics/subscription/subscriptionAnalytics'
import ContentAnalytics from '../views/container/analytics/content/contentAnalytics'
import ServiceNotAllowed from '../views/container/serviceNotAllowed'
import Page404 from '../views/container/page404/Page404'
import TaxHead from '../views/container/pricing/TaxHead'
import HomePageWeb from '../views/container/HomePageWeb/HomePageWeb'
import PaymentGateway from '../views/container/pricing/PaymentGateway'
import PayPerView from '../views/container/pricing/PayPerView'
import ContentListing from '../views/container/cms/ContentListing'
import { checkModuleAllowed, checkPermissions } from '../views/utils/helper'
import LiveStreamListing from '../views/container/live/liveStreamListing'
import { AppContext } from '../views/context/app'
import ManageLeads from '../views/container/leads'
import TemplateListing from 'src/views/container/templates/templateListing'
import TemplateEditor from 'src/views/container/templates/templateEditor'
import Affiliates from '../views/container/affiliates'
import AffiliatesDetail from '../views/container/affiliates/affiliatesDetail'
import ContentPartner from 'src/views/container/contentPartner'
import ContentPartnerAnalytics from 'src/views/container/analytics/contentPartner/contentPartnerAnalytics'
import PartnerAnalytics from 'src/views/container/contentPartner/partnerAnalytics'
import LiveStreamDetail from 'src/views/container/live/liveStreamDetail'
import IPTVChannels from 'src/views/container/iptvChannels'
import ChannelSchedule from 'src/views/container/iptvChannels/channelSchedule'
import AffiliatesAnalytics from '../views/container/affiliates/analytics'
import AffiliateAnalyticsDetail from '../views/container/affiliates/affiliateAnalyticsDetail'
import StaticPageListing from 'src/views/container/customStaticPages/staticPageListing'
import StaticPageEditor from 'src/views/container/customStaticPages/staticPageEditor'
import CustomPageListing from 'src/views/container/customStaticPages/customPageListing'
import EmailTemplate from 'src/views/container/emailTemplate'
import AddTemplate from 'src/views/container/emailTemplate/AddTemplate'
import AssetListing from 'src/views/container/AssetManager/AssetListing'
import CustomForms from 'src/views/container/customForms'
import CustomFormAnalytics from 'src/views/container/customForms/customFormAnalytics'
import FormAnalyticsDetails from 'src/views/container/customForms/formAnalyticsDetails'
import Campaign from 'src/views/container/campaign'
import CreateCampaign from 'src/views/container/campaign/createCampaign'
import CampaignAudience from 'src/views/container/campaign/audience'
import CreateCampaignAudience from 'src/views/container/campaign/audience/createCampaignAudience'
import CreateCampaignEmailTemplate from 'src/views/container/campaign/emailTemaplate/createCampaignEmailTemplate'
import CampaignChooseTemplate from 'src/views/container/campaign/emailTemaplate/campaignChooseTemplate'
import CampaignEmailTemplateList from '../views/container/campaign/emailTemaplate'
import ManageTemplates from 'src/views/container/manageTemplates'
import LeadPartner from '../views/container/customForms/leadPartner'
import LeadPartnerAnalytics from '../views/container/customForms/leadPartner/leadPartnerAnalytics'

const routes = [
  {
    path: '/',
    exact: true,
    name: 'Home',
    moduleName: 'home',
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    moduleName: 'dashboard',
  },
  {
    path: '/content-create',
    name: 'Create Content',
    component: CreateContent,
    permission: [PERMISSIONS.CONTENT.CREATE],
    moduleName: 'cms',
  },
  {
    path: '/content',
    name: 'Content',
    component: ContentListing,
    permission: [PERMISSIONS.CONTENT.READ],
    moduleName: 'cms',
  },
  {
    path: '/manage-accounts',
    name: 'Manage Account',
    component: CreateEditAccounts,
    type: 'Basic',
    permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
    moduleName: 'account',
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: Subscription,
    permission: [PERMISSIONS.PRICING.READ],
    moduleName: 'subscription',
  },
  {
    path: '/pay-per-view',
    name: 'Pay Per View',
    component: PayPerView,
    permission: [PERMISSIONS.PRICING.READ],
    moduleName: 'ppv',
  },
  {
    path: '/payment-gateway',
    name: 'PaymentGateway',
    component: PaymentGateway,
    permission: [PERMISSIONS.PAYMENT_GATEWAY.READ],
    moduleName: 'payment_gateway',
  },
  {
    path: '/asset-Manager',
    name: 'Asset Manager',
    // component: AssetDashboard,
    component: AssetListing,
    permission: [PERMISSIONS.CONTENT.READ],
    moduleName: 'asset_manager',
  },
  {
    path: '/censorship-rating',
    name: 'Content Rating',
    component: ContentRating,
    permission: [PERMISSIONS.CONTENT.READ],
    moduleName: 'content_rating',
  },
  {
    path: '/system-defined',
    name: 'System Defined',
    component: SystemDefined,
    permission: [PERMISSIONS.META_DATA.READ],
    moduleName: 'metadata',
  },
  {
    path: '/custom-fields',
    name: 'Custom Fields',
    component: CustomMetaDataListing,
    permission: [PERMISSIONS.META_DATA.READ],
    moduleName: 'metadata',
  },
  {
    path: '/home-page-web',
    name: 'Home Page',
    component: HomePageWeb,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/custom-forms/list',
    name: 'Custom Forms',
    component: CustomForms,
    permission: [PERMISSIONS.CUSTOM_FORMS.READ],
    moduleName: 'custom_forms',
  },
  {
    path: '/custom-forms/analytics/:formId',
    name: 'Custom Forms Analytics Detail',
    component: FormAnalyticsDetails,
    permission: [PERMISSIONS.CUSTOM_FORMS.READ],
    moduleName: 'custom_forms',
  },
  {
    path: '/custom-forms/lead-partner/analytics/:partnerId',
    name: 'Custom Forms Partner Analytics Detail',
    component: LeadPartnerAnalytics,
    permission: [PERMISSIONS.CUSTOM_FORMS.UPDATE],
    moduleName: 'custom_forms',
  },
  {
    path: '/custom-forms/lead-partners',
    name: 'Lead Partners',
    component: LeadPartner,
    permission: [PERMISSIONS.CUSTOM_FORMS.CREATE],
    moduleName: 'custom_forms',
  },
  {
    path: '/custom-forms/analytics',
    name: 'Custom Forms Analytics',
    component: CustomFormAnalytics,
    permission: [PERMISSIONS.CUSTOM_FORMS.READ],
    moduleName: 'custom_forms',
  },
  {
    path: '/templates',
    name: 'templates',
    component: TemplateListing,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/template-editor/:templateId',
    name: 'template editor',
    component: TemplateEditor,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/template-preview',
    name: 'template preview',
    component: TemplateEditor,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/static-container',
    name: 'Static Pages',
    component: StaticPages,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/static-pages',
    name: 'static pages',
    component: StaticPageListing,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/custom-editor/:pageId',
    name: 'static editor',
    component: StaticPageEditor,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/static-editor/:pageId',
    name: 'static editor',
    component: StaticPageEditor,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/custom-pages',
    name: 'custom pages',
    component: CustomPageListing,
    permission: [PERMISSIONS.WEBSITE.READ],
    moduleName: 'website',
  },
  {
    path: '/tax',
    name: 'Tax',
    component: TaxHead,
    permission: [PERMISSIONS.PRICING.READ],
    moduleName: 'tax',
  },
  {
    path: '/discount',
    name: 'Discount',
    component: Discount,
    type: 'disc',
    permission: [PERMISSIONS.DISCOUNT.READ],
    moduleName: 'discount',
  },
  {
    path: '/voucher',
    name: 'Voucher',
    component: Discount,
    type: 'vouch',
    permission: [PERMISSIONS.DISCOUNT.READ],
    moduleName: 'discount',
  },
  {
    path: '/user-discount',
    name: 'User Discount',
    component: Discount,
    type: 'udisc',
    permission: [PERMISSIONS.DISCOUNT.READ],
    moduleName: 'discount',
  },
  {
    path: '/user-voucher',
    name: 'User Voucher',
    component: Discount,
    type: 'uvouch',
    permission: [PERMISSIONS.DISCOUNT.READ],
    moduleName: 'discount',
  },
  {
    path: '/manage-accounts',
    name: 'Create Admin Account',
    component: ManageAccounts,
    moduleName: 'account',
    // permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
  },
  {
    path: '/create-admin-accounts',
    name: 'Create Admin Account',
    component: CreateEditAccounts,
    type: 'accounts',
    moduleName: 'account',
    permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
  },
  {
    path: '/roles-management',
    name: 'Roles Management',
    component: RolesList,
    permission: [PERMISSIONS.USER_MANAGEMENT.READ],
    moduleName: 'user_management',
  },
  {
    path: '/cms-users',
    name: 'CMS Users',
    component: CmsUserList,
    permission: [PERMISSIONS.USER_MANAGEMENT.READ],
    moduleName: 'user_management',
  },

  {
    path: '/subscribers',
    name: 'Subscribers',
    component: SubscriberList,
    permission: [PERMISSIONS.USER_MANAGEMENT.READ],
    moduleName: 'user_management',
  },
  {
    path: '/user-groups',
    name: 'User Groups',
    component: UserGroupList,
    permission: [PERMISSIONS.USER_MANAGEMENT.READ],
    moduleName: 'user_management',
  },
  {
    path: '/content-partners',
    name: 'Content Partner',
    component: ContentPartner,
    permission: [PERMISSIONS.CONTENT_PARTNER.READ],
    moduleName: 'content_partner',
  },
  {
    path: '/partner-analytics',
    name: 'Partner Analytics',
    component: PartnerAnalytics,
    permission: [PERMISSIONS.CONTENT_PARTNER.READ],
    moduleName: 'content_partner',
  },
  {
    path: '/artist',
    name: 'Artists',
    component: Artists,
    permission: [PERMISSIONS.ARTIST.READ],
    moduleName: 'artist',
  },
  {
    path: '/artist-types',
    name: 'Artist Types',
    component: ArtistsTypes,
    permission: [PERMISSIONS.ARTIST.READ],
    moduleName: 'artist',
  },
  {
    path: '/venue',
    name: 'Venues',
    component: Venues,
    permission: [PERMISSIONS.VENUE.READ],
    moduleName: 'venue',
  },
  {
    path: '/iptv-channels',
    name: 'IPTV Channels',
    component: IPTVChannels,
    permission: [PERMISSIONS.IPTV_MODULE.READ],
    moduleName: 'iptv_module',
  },
  {
    path: '/iptv-schedule/:channelId',
    name: 'IPTV Schedule',
    component: ChannelSchedule,
    permission: [PERMISSIONS.IPTV_MODULE.READ],
    moduleName: 'iptv_module',
  },
  {
    path: '/campaign/marketing-fields',
    name: 'Marketing Fields',
    component: CustomMetaDataListing,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/list',
    name: 'Campaign',
    component: Campaign,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/create',
    name: 'Create Campaign',
    component: CreateCampaign,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/edit/:campaignId',
    name: 'Edit Campaign',
    component: CreateCampaign,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/choose-templates',
    name: 'Campaign Templates',
    component: CampaignChooseTemplate,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/mail-templates/list',
    name: 'Mail Templates',
    component: CampaignEmailTemplateList,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/mail-templates/edit/:mailTemplateId',
    name: 'Edit Mail Template',
    component: CreateCampaignEmailTemplate,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/mail-templates/create',
    name: 'Create Mail Template',
    component: CreateCampaignEmailTemplate,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/audience/list',
    name: 'Audience',
    component: CampaignAudience,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/audience/create',
    name: 'Create Audience',
    component: CreateCampaignAudience,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing',
  },
  {
    path: '/campaign/audience/edit/:audienceId',
    name: 'Edit Audience',
    component: CreateCampaignAudience,
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
    moduleName: 'campaign_marketing_audience',
  },
  {
    path: '/affiliates/detail/:affiliateId',
    name: 'Affiliates Detail',
    component: AffiliatesDetail,
    permission: [PERMISSIONS.AFFILIATES.READ],
    moduleName: 'affiliates',
  },
  {
    path: '/affiliates-analytics',
    name: 'Affiliates',
    component: AffiliatesAnalytics,
    permission: [PERMISSIONS.AFFILIATES.READ],
    moduleName: 'affiliates',
  },
  {
    path: '/affiliates/analytics/:affiliateId',
    name: 'Affiliates Detail',
    component: AffiliateAnalyticsDetail,
    permission: [PERMISSIONS.AFFILIATES.READ],
    moduleName: 'affiliates',
  },
  {
    path: '/affiliates',
    name: 'Affiliates',
    component: Affiliates,
    permission: [PERMISSIONS.AFFILIATES.READ],
    moduleName: 'affiliates',
  },
  {
    path: '/404',
    name: '404',
    component: Page404,
  },
  // {
  //   path: '/mobile-apps',
  //   name: 'Mobile Apps',
  //   component: ServiceNotAllowed,
  //   moduleName: 'mobile_app',
  //   permission: [PERMISSIONS.MOBILE_APP.READ],
  // },
  {
    path: '/tv-mobile-apps',
    name: 'TV / Mobile Apps',
    component: HomePageWeb,
    moduleName: 'mobile_app',
    permission: [PERMISSIONS.MOBILE_APP.READ, PERMISSIONS.TV_APP.READ],
  },
  {
    path: '/subscription-analytics',
    name: 'Subscription Analytics',
    component: SubscriptionAnalytics,
    moduleName: 'analytics',
    permission: [PERMISSIONS.ANALYTICS.READ],
  },
  {
    path: '/content-analytics',
    name: 'Content Analytics',
    component: ContentAnalytics,
    moduleName: 'analytics',
    permission: [PERMISSIONS.ANALYTICS.READ],
  },
  {
    path: '/content-partner-analytics',
    name: 'Content Partner Analytics',
    component: ContentPartnerAnalytics,
    moduleName: 'analytics',
    permission: [PERMISSIONS.ANALYTICS.READ],
  },
  {
    path: '/live-stream',
    name: 'Live Stream',
    component: LiveStreamListing,
    moduleName: 'live',
    permission: [PERMISSIONS.LIVE.READ],
  },
  {
    path: '/live-detail/:liveId',
    name: 'Live Stream Detail',
    component: LiveStreamDetail,
    moduleName: 'live',
    permission: [PERMISSIONS.LIVE.READ],
  },
  {
    path: '/email-template',
    name: 'Mail Management',
    component: EmailTemplate,
    permission: [PERMISSIONS.EMAIL_TEMPLATE.READ, PERMISSIONS.EMAIL_TEMPLATE.UPDATE],
    moduleName: 'email_template',
  },
  {
    path: '/email-template-edit',
    name: 'Mail Edit',
    component: AddTemplate,
    permission: [PERMISSIONS.EMAIL_TEMPLATE.UPDATE, PERMISSIONS.EMAIL_TEMPLATE.CREATE],
    moduleName: 'email_template',
  },
  {
    path: '*',
    name: 'Dashboard',
    component: Dashboard,
  },
]

const Routing = ({ isTemplateRoute, isIptvRoute }) => {
  let customerId = localStorage.getItem('customer_id')
  let sessionId = localStorage.getItem('sessionId')
  const { userSessionObj, signedIn, userObj } = useContext(GlobalContext)
  const { accountObj } = useContext(AppContext)
  const location = useLocation()
  const history = useHistory()

  const getFilteredRoute = () => {
    const permissions = userSessionObj.session_data.permissions
    let newRoutes = []
    if (!userObj.is_super_user) {
      routes.forEach((route) => {
        let newRoute = {}
        if (route.permission) {
          if (checkPermissions(permissions, route.permission)) {
            newRoute = route
          }
        } else {
          newRoute = route
        }
        if (newRoute && newRoute.moduleName) {
          const isAllowed = checkModuleAllowed(route.moduleName, accountObj.module_permissions)
          newRoute = { ...newRoute, component: isAllowed ? route.component : ServiceNotAllowed }
        }
        if (newRoute) {
          newRoutes.push(newRoute)
        }
      })
    } else {
      newRoutes = [
        {
          path: '/manage-accounts',
          name: 'Manage Account',
          component: ManageAccounts,
          permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
        },
        {
          path: '/create-admin-accounts',
          name: 'Create Admin Account',
          component: CreateEditAccounts,
          type: 'accounts',
          permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
        },
        {
          path: '/manage-leads',
          name: 'Manage Leads',
          component: ManageLeads,
          type: 'leads',
          permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
        },
        {
          path: '/manage-templates',
          name: 'Manage Templates',
          component: ManageTemplates,
          type: 'templated',
          permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
        },
        {
          path: '*',
          name: 'Manage Account',
          component: ManageAccounts,
        },
      ]
    }
    return newRoutes
  }

  const handleRedirectLogin = () => {
    history.push({ pathname: '/login', state: location.pathname })
  }

  return (
    <div
      className={`${!isTemplateRoute && !isIptvRoute && 'container-lg'} ${
        isIptvRoute && 'iptv-schedule-container'
      }`}
    >
      <Switch>
        {customerId && sessionId && signedIn
          ? getFilteredRoute().map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => <route.component {...props} type={route.type} />}
                  />
                )
              )
            })
          : handleRedirectLogin()}
      </Switch>
    </div>
  )
}

export default Routing
